var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          ref: "menu",
          staticClass: "vks-variant-dot-menu",
          style: _vm.menuStyle,
          attrs: { role: "menu" },
          on: {
            mousedown: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("p", { staticClass: "vks-variant-dot-menu-title" }, [
            _vm._v(_vm._s(_vm.variantId)),
          ]),
          _c(
            "button",
            {
              staticClass: "vks-variant-dot-menu-btn",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("set-reference")
                },
              },
            },
            [_vm._v(" Set as reference variant ")]
          ),
          _c(
            "button",
            {
              staticClass: "vks-variant-dot-menu-btn",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("toggle-star")
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.isStarred ? "Unstar variant" : "Star variant") +
                  " "
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }